import {
  GraphAnxietyWorry,
  GraphEmotionalSupport,
  GraphFamilyActivities,
  GraphFatigue,
  GraphFunctionPhysical,
  GraphFunctionPositive,
  GraphFunctionSocial,
  GraphPeerRelations,
  GraphPhysicalStress,
  GraphSchool,
  GraphSleep,
  GraphSocialBehavior,
  GraphSocialRole,
  GraphSocialSupport,
} from './svg';
import {
  YAAlcohol,
  YAAnxietyWorry,
  YABodyFunction,
  YABodyLimit,
  YABodyType,
  YAEmotionLimit,
  YAGoal,
  YAMentalHealth,
  YAPhone,
  YAPhysical,
  YASmoke,
  YASocial,
  YASprout,
  YAStress,
} from './svg/youngadult';
interface IconMap {
  [key: string]: string;
}
let iconMap: IconMap = {
  PAR_B_1: GraphSleep,
  PAR_B_2: GraphFatigue,
  PAR_B_3: GraphFunctionPhysical,
  PAR_B_4: GraphSleep,
  PAR_B_5: GraphFatigue,
  PAR_B_6: GraphFunctionPhysical,
  PAR_M_1: GraphAnxietyWorry,
  PAR_M_2: GraphAnxietyWorry,
  PAR_M_3: GraphFunctionPositive,
  PAR_R_1: GraphSchool,
  PAR_S_1: GraphFamilyActivities,
  PAR_S_2: GraphEmotionalSupport,
  PAR_S_3: GraphSocialSupport,
  PAR_S_4: GraphFunctionSocial,
  PAR_S_5: GraphSocialBehavior,
  PAR_S_6: GraphFamilyActivities,
  PAR_S_7: GraphSocialRole,
  PAR_S_8: GraphFamilyActivities,
  PAR_S_9: GraphFamilyActivities,
  PAR_S_10: GraphFamilyActivities,
  CHI_B_1: GraphFunctionPhysical,
  CHI_M_1: GraphAnxietyWorry,
  CHI_R_2: GraphSchool,
  CHI_S_1: GraphPeerRelations,
  // YoungAdult 설문
  CHI_B_11: YAPhysical, // 신체건강_신체활동
  CHI_B_12: YAAlcohol, // 신체건강_음주력
  CHI_B_13: YASmoke, // 신체건강_흡연
  CHI_M_10: YAStress, // 정신건강_스트레스
  CHI_M_11: YAAnxietyWorry, // 정신건강_우울감
  CHI_M_12: YAAnxietyWorry, // 정신건강_불안감
  CHI_M_13: YABodyType, // 정신건강_신체이미지
  CHI_M_14: YAGoal, // 정신건강_목표지향_새로운가능성
  CHI_M_15: YAGoal, // 정신건강_목표지향_내적역량강화
  CHI_S_11: YASocial, // 사회적건강_사회적지지
  CHI_S_12: YAPhone, // 사회적건강_스마트폰사용경험
  CHI_C_11: YABodyFunction, // 사회적건강_건강관련삶의질_신체기능
  CHI_C_12: YABodyLimit, // 사회적건강_건강관련삶의질_신체적역할제한
  CHI_C_13: YAEmotionLimit, // 사회적건강_건강관련삶의질_감정적역할제한
  CHI_C_14: YASocial, // 사회적건강_건강관련삶의질_사회적기능
  CHI_C_15: GraphPhysicalStress, // 사회적건강_건강관련삶의질_신체통증
  CHI_C_16: YASprout, // 사회적건강_건강관련삶의질_전반적건강
  CHI_C_17: YASprout, // 사회적건강_건강관련삶의질_활력
  CHI_C_18: YAMentalHealth, // 사회적건강_건강관련삶의질_정신건강
  CHI_C_19: YASprout, // 사회적건강_건강관련삶의질_건강변화
};

export default iconMap;
